import type { LucideIcon } from "lucide-react";
import {
  AtSign,
  FilePlus,
  IdCard,
  MessageCircleQuestion,
  PenLine,
  Receipt,
  Ticket,
  UserRoundCheck,
} from "lucide-react";

export type RequestTypeVisual = { icon: LucideIcon; className: string };

/**
 * One icon and colour per kind of ask, shared by the request dialog and the requests list, so a
 * pièce reads the same where it is asked and where it is followed. Keyed by the pièce's document
 * type for a DOCUMENT, by the request kind otherwise.
 */
const VISUALS: Record<string, RequestTypeVisual> = {
  ID_PROOF: { icon: IdCard, className: "text-purple-600" },
  ETICKET: { icon: Ticket, className: "text-blue-600" },
  PROOF_OF_EXPENSE: { icon: Receipt, className: "text-amber-600" },
  EMAIL: { icon: AtSign, className: "text-teal-600" },
  LEGAL_REPRESENTATIVE: { icon: UserRoundCheck, className: "text-violet-600" },
  QUESTION: { icon: MessageCircleQuestion, className: "text-pink-600" },
  SIGNATURE: { icon: PenLine, className: "text-indigo-600" },
};

/** Any other document type (« Autre », custom pièces) shares one neutral icon. */
const OTHER_DOCUMENT: RequestTypeVisual = { icon: FilePlus, className: "text-gray-600" };

export function requestTypeVisual(key: string | null): RequestTypeVisual {
  return (key && VISUALS[key]) || OTHER_DOCUMENT;
}

/** The key of a listed request: its pièce for a DOCUMENT, its kind otherwise. */
export function requestVisualKey(request: { type: string; claimDocumentType: string | null }): string | null {
  return request.type === "DOCUMENT" ? request.claimDocumentType : request.type;
}
